module.exports = __webpack_public_path__ + "static/img/btn_android.fcce0da3.svg";